// extracted by mini-css-extract-plugin
export var aboveInput = "_o8-0";
export var actionButton = "_o8-5";
export var actionButtonContainer = "_o8-1";
export var actionIcon = "_o8-6";
export var aiInfoContainer = "_o8-2";
export var attachmentWrapper = "_o8-7";
export var bold = "_o8-3";
export var checkIcon = "_o8-8";
export var clickingRecipientBar = "_o8-11";
export var commentThreadSwitch = "_o8-a";
export var draftImage = "_o8-b";
export var draftImageContainer = "_o8-c";
export var draftImages = "_o8-e";
export var editButton = "_o8-g";
export var editor = "_o8-f";
export var editorContainer = "_o8-y";
export var editorErrorTooltipWrapper = "_o8-9";
export var headerDivider = "_o8-h";
export var icon = "_o8-i";
export var info = "_o8-j";
export var internal = "_o8-n";
export var internalDivider = "_o8-k";
export var internalMessage = "_o8-l";
export var messageInputCard = "_o8-m";
export var messageInputForm = "_o8-o";
export var messageInputFormInternal = "_o8-p";
export var options = "_o8-q";
export var publicMessageCustomer = "_o8-s";
export var publicMessageMerchant = "_o8-r";
export var removeImageButton = "_o8-d";
export var replyButtons = "_o8-t";
export var showSignatureButton = "_o8-u";
export var spinner = "_o8-v";
export var verticalButtonDivider = "_o8-4";
export var visibilitySelector = "_o8-w";
export var warning = "_o8-x";
export var wrappingText = "_o8-z";
export var writingInternalNoteTopBorder = "_o8-10";